import React, { useState } from "react";
import Card from "../../Shared/Card/Card.component";

import { faMicrophoneSlash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import Pin from '../../../svgs/pin-svgrepo-com.svg'
import UnPin from '../../../svgs/pin-slash-svgrepo-com.svg'

import "./Participant.css";

export const Participant = ({ pinnedIndex, curentIndex, currentParticipant, hideVideo, videoRef, showAvatar, currentUser, showParticipants, onPin, element, hasPinned }) => {
  const [pinned, setPinned] = useState(false)

  if (!currentParticipant) return <></>;

  const primaryStyle = {
    width: '100%',
    height: '90%'
  }

  const wrapperProps = {
    className: `participant${hideVideo ? " hide" : ""}${currentUser ? ' primary' : ''}${pinned ? " pinned" : " unpinned"}`,
    style: { ...(currentUser ? primaryStyle : { minHeight: '100%' }) }
  }

  const videoProps = {
    style: { minHeight: '100%' },
    ref: videoRef,
    className: "video",
    id: `participantVideo${curentIndex}`,
    autoPlay: true,
    playsInline: true
  } 

  const wrapperPinProps = {
    className: "wrapper-pin",
    onClick: () => {
      setPinned(prev => !prev)
      onPin && onPin({ index: curentIndex, hasPinned: !pinned }, element)
    }
  }

  const pinProps = {
    className: 'pin',
    src: !pinned ? UnPin : Pin
  }

  const microphoneProps = {
    className: "muted",
    icon: faMicrophoneSlash,
    title: "Muted"
  }

  const avatarProps = {
    style: { background: currentParticipant.avatarColor, width: '40%', height: '60%', fontSize: '400%' },
    className: "avatar"
  }

  const nameProps = {
    className: "name"
  }

  return (
    <div {...wrapperProps}>
      <Card>
        <video {...videoProps}></video>

        <div {...wrapperPinProps}><img  {...pinProps} alt="pin" /></div>

        {!currentParticipant.audio && <FontAwesomeIcon {...microphoneProps} />}

        {showAvatar && <div {...avatarProps}>{currentParticipant.name[0]}</div>}

        <div {...nameProps}>{currentParticipant.name}{currentUser ? "(Você)" : ""}</div>
      </Card>
    </div>
  );
};
